module.exports = __webpack_public_path__ + "static/15_norsk-b94cd91981181e91822ce214ff2abc98.png";